import { ScopeName } from './Scope';

const TranslationHomePage = {
  [`${ScopeName}.title`]: 'Página Home',
  [`${ScopeName}.msgErrorModule`]: 'Não foi possível carregar o módulo federado',
};

export default TranslationHomePage;
